import { Button, IconButton } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { FaExternalLinkAlt, FaEye, FaHistory } from 'react-icons/fa';
import PopupModal from '../../PopupModal';
import { useLazyGetPastMovementsOfSameTemplateAndMissionQuery } from 'modules/pvs_activities/redux/service/movements';
import { FormDataContext } from '../../contexts/FormContext';
import { MOVEMENTS_STATUS } from 'modules/pvs_activities/constants';
import { flipKeyValueInObject, processVariables } from 'modules/pvs_activities/helper.general';
import _ from 'lodash';
import { getBaseURL, sendAPIRequest } from 'helpers';
import PopupForm from 'modules/pvs_activities/pages/forms/PopupForm';
import { useGetFormDataVariablesQuery } from 'modules/pvs_activities/redux/service/formData';

const defaultProps = {
    className: '',
    movementId: '',
    templateId: '',
    title: 'View Security History',
};

const ViewTaskHistoryModal = (rawProps) => {
    const props = { ...defaultProps, ...rawProps };

    const [tableCustomColumns, setTableCustomColumns] = useState([]);

    const formDataContext = useContext(FormDataContext);
    const [dataTrigger, dataRes] = useLazyGetPastMovementsOfSameTemplateAndMissionQuery();

    const fetchData = async () => {
        try {
            const res = await sendAPIRequest(`/api/pvsa/history-movement-column?template_id=${formDataContext.templateId}`, 'GET');
            const data = await res.json();
            if (data.success) {
                setTableCustomColumns(data.data);
                console.log("Filtered data:", data.data);
            }
        } catch (error) {
            console.error("Error fetching filtered data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const getStatusFromValue = (val) => {
        const obj = flipKeyValueInObject(MOVEMENTS_STATUS);
        return _.capitalize(obj[val] ?? '-')
    }

    const variablesRes = useGetFormDataVariablesQuery(formDataContext.missionId, {
        skip: formDataContext.mode !== "data_entry"
    });
    return (
        <PopupModal
            title={props.title}
            size="xl"
            triggers={({ openModal }) => (
                <Button
                    variant="contained"
                    color="primary"
                    className={props.className}
                    onClick={openModal}
                >
                    <FaHistory className="me-1" />
                    {/* <span>View Security History</span> */}
                    <span>{props.title}</span>
                </Button>
            )}
            onOpen={() => {
                if (formDataContext.mode === 'data_entry') {
                    dataTrigger({
                        movementId: formDataContext.movementId,
                        templateId: formDataContext.templateId,
                    });
                }
            }}
        >
            <div className="table-responsive">
                <table className="table table-bordered">
                    <thead className="bg-primary text-white">
                        <tr>
                            <th className="text-center">#</th>
                            <th className="text-center">Status</th>
                            {tableCustomColumns?.length > 0 &&
                                tableCustomColumns.map((col, index) => (
                                    <th className="text-center" key={index}>{col.column_name}</th>
                                ))
                            }
                            <th className="text-center">Submission User</th>
                            <th className="text-center">Submission Date</th>
                            <th className="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(dataRes.isSuccess && dataRes.data.length === 0) || dataRes.isUninitialized ? (
                            <tr>
                                <td className="text-center" colSpan={5 + tableCustomColumns?.length}>
                                    No Data Found
                                </td>
                            </tr>
                        ) : dataRes.isError ? (
                            <tr>
                                <td className="text-center" colSpan={5 + tableCustomColumns?.length}>
                                    Error loading data!
                                </td>
                            </tr>
                        ) : dataRes.isLoading ? (
                            <tr>
                                <td className="text-center" colSpan={5 + tableCustomColumns?.length}>
                                    Loading...
                                </td>
                            </tr>
                        ) : dataRes.isSuccess ? (
                            dataRes.data.map((r, k) => (
                                <tr key={r.id}>
                                    <td className="text-center">{k + 1}</td>
                                    <td className="text-center">{getStatusFromValue(r.status)}</td>
                                    {r.relationForm?.relationHistoryColumn?.length > 0 &&
                                        r.relationForm?.relationHistoryColumn.map((col, index) => (
                                            <td className="text-center" key={index}>{col.variable_value}</td>
                                        ))
                                    }
                                    <td className="text-center">{r.user_name}</td>
                                    <td className="text-center">{r.completed_date_formatted}</td>
                                    <td className="text-center">
                                        {r.is_popup_form ? (
                                            <PopupForm
                                                mode={"data_entry"}
                                                id={r.d_form_id}
                                                movementId={r.movement_id}
                                            >
                                                {(openModal) => (
                                                    <IconButton
                                                        color="primary"
                                                        onClick={() => openModal()}
                                                        size="small"
                                                    >
                                                        <FaEye className="me-1" />
                                                        <span>Open</span>
                                                    </IconButton>
                                                )}
                                            </PopupForm>
                                        ) : (
                                            <a
                                                href={getBaseURL(`/portal/pvs-activities/dform-view/${r.d_form_id}/${r.id}`)}
                                                target='_blank'
                                                rel="noreferrer"
                                            >
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => { }}
                                                    size="small"
                                                >
                                                    <FaExternalLinkAlt className="me-1" />
                                                    <span>Open</span>
                                                </IconButton>
                                            </a>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : null}
                    </tbody>
                </table>
            </div>
        </PopupModal>
    );
}

export default ViewTaskHistoryModal;
